import clsx from "clsx"
import { ReactNode, useState } from "react"
import { createPortal } from "react-dom"

import useNavTopBar, { NavTopBarContext } from "./NavTopBar.context"
import styles from "./NavTopBar.module.scss"
import { NavTopBarProps } from "./NavTopBar.types"
import NavTopBarCTAButton from "./NavTopBarCTAButton/NavTopBarCTAButton"
import NavTopBarContextMenu from "./NavTopBarContextMenu/NavTopBarContextMenu"
import NavTopBarHeader from "./NavTopBarHeader/NavTopBarHeader"
import NavTopBarHeaderEnd from "./NavTopBarHeader/NavTopBarHeaderEnd/NavTopBarHeaderEnd"
import NavTopBarHeaderStart from "./NavTopBarHeader/NavTopBarHeaderStart/NavTopBarHeaderStart"
import NavTopBarPageInnerTitle from "./NavTopBarPageInnerTitle/NavTopBarPageInnerTitle"
import NavTopBarPagePresence from "./NavTopBarPagePresence/NavTopBarPagePresence"
import NavTopBarPageTitle from "./NavTopBarPageTitle/NavTopBarPageTitle"
import NavTopBarSearchButton from "./NavTopBarSearchButton/NavTopBarSearchButton"
import NavTopBarTabs from "./NavTopBarTabs/NavTopBarTabs"
import useNavTopBarMobileTabs from "./hooks/useNavTopBarMobileTabs"

function NavTopBarProvider(props: NavTopBarProps) {
    const { children } = props

    const [topBarRef, setNavTopBarRef] = useState<HTMLDivElement | null>(null)
    const [mobileTabsRef, setMobileTabsRef] = useState<HTMLDivElement | null>(null)

    return (
        <NavTopBarContext.Provider value={{ topBarRef, setNavTopBarRef, mobileTabsRef, setMobileTabsRef }}>
            {children}
        </NavTopBarContext.Provider>
    )
}

function NavTopBar(props: NavTopBarProps) {
    const { children } = props

    const { setNavTopBarRef } = useNavTopBar()

    return (
        <div className={clsx(styles.base, "jsNavTopBar")} data-topbar-portal={true} ref={setNavTopBarRef}>
            {children}
            <NavTopBarMobileTabsSlot />
        </div>
    )
}

function NavTopBarMobileTabsSlot() {
    const { mobileTabsRef } = useNavTopBarMobileTabs()

    return <div ref={mobileTabsRef} className={styles.mobileTabs} />
}

function NavTopBarPortal(props: { children: ReactNode }) {
    const { children } = props

    const { topBarRef } = useNavTopBar()

    if (!topBarRef) {
        return null
    } else {
        return createPortal(children, topBarRef)
    }
}

const Root = NavTopBar
const Tabs = NavTopBarTabs
const PageTitle = NavTopBarPageTitle
const PageInnerTitle = NavTopBarPageInnerTitle
const SearchButton = NavTopBarSearchButton
const CTAButton = NavTopBarCTAButton
const ContextMenu = NavTopBarContextMenu
const Header = NavTopBarHeader
const Portal = NavTopBarPortal
const PagePresence = NavTopBarPagePresence
const Provider = NavTopBarProvider

export default {
    Root,
    Tabs,
    NavTopBarHeaderStart,
    NavTopBarHeaderEnd,
    Header,
    PageTitle,
    PageInnerTitle,
    SearchButton,
    CTAButton,
    ContextMenu,
    Portal,
    PagePresence,
    Provider,
}
